
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function TemplateBaseIndex() {
  return (
    <NonFSIndex
      data_type="template_base"
    />
  );
}
